<script>
  import { customerMethods, customerListComputed, layoutMethods, exportMethods,erpFixMessages, peddlrWalletKycMethods, peddlrWalletKycComputed } from "@/state/helpers";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import Swal from "sweetalert2";
  import Paginationv2 from "@/components/Pagination-v2";
  //import moment from 'moment-timezone';

/**
 * Modified by  : John Mark Arquitola
 * Date modified: May 31, 2022
 * Description  : Change subscriber label into merchant
 * 
 * Merchant information component
 */
export default {
  page: {
    title: "Merchant information"
  },
  data() {
    return {
      title: "Merchant information",
      dataList: [],      
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      filter: null,
      filterOn: [],
      sortBy: "value",
      sortDesc: false,
      fields: [
        { key: "name", sortable: true, tdClass: "align-middle" },
        { key: "business_name", sortable: true, tdClass: "align-middle" },
        { key: "storeCategory", sortable: true, tdClass: "align-middle" },
        { key: "mdr",label:"MDR", sortable: false, tdClass: "align-middle" },
        { key: "contact_info", sortable: true, tdClass: "align-middle" },
        { key: "KYC_account_status", sortable: true, tdClass: "align-middle" },
        { key: "wallet_account_number", sortable: true, tdClass: "align-middle" },
        { key: "kyc_verified_at", label: "KYC Verification Date", sortable: true, tdClass: "align-middle" },
        { key: "wallet_user", sortable: false, tdClass: "align-middle" },
        { key: "kk_registration_date", sortable: true, tdClass: "align-middle", label: "KK Registration Date" },
        { key: "registered", sortable: true, tdClass: "align-middle" },
      ],
      view: {
        name: '',
        businessName: '',
        number: '',
        email: '',
        address: '',

      },
      coinvalue: "",
      statusValue: "",
      typeValue: null,
      datepickervalue: "",
      showModal: false,
      submitted: false,

      selected: null,
      options: [
        { value: 'A', text: 'TM (from options prop)' },
        { value: 'B', text: 'Globe (from options prop)' }
      ],

      searchValue: {
        search: null,
        searchField: null,
        kycStatus : null,
        kycAccountType : null,
        kycAccountStatus : null,
        walletUser : null,
        dateRange: null,
        sort: 'id',
        orderDesc: true,
        dateKeyword: 'created_at',
        mdrUser:null,
        storeCategory:null,
      },
      searchList: [
        { text: 'Search All', value: null },
        { text: 'Name', value: 'u.name' },
        { text: 'Business Name', value: 'b.name' },
        { text: 'Mobile Number', value: 'u.mobile_number' },
        { text: 'Email', value: 'u.email' },
        // { text: 'KYC Account Type', value: 'u.kyc_acct_type' },
        // { text: 'KYC Account Status', value: 'u.kyc_acct_status' },
        { text: 'Wallet Account Number', value: 'u.acct_no' },
        // { text: 'Wallet User', value: 'walletUser' },
      ],
      kycList: [
        { text: 'All', value: null },
        { text: 'Don\'t have KYC', value: 'n' },
        { text: 'Verified', value: 'v' },
        { text: 'Manual', value: 'm' },
        { text: 'Rejected', value: 'r' },
        { text: 'Max-image', value: 'mi' }
      ],
      kycAccountTypeList: [
        { text: 'All', value: null },
        { text: 'Fully Verified', value: 'FullyVerified' },
        { text: 'Failed KYC', value: 'FailedKYC' },
        { text: 'Don\'t have KYC', value: 'NoKYC' },
        { text: 'Manual KYC', value: 'ManualKYC' },
      ],
      storeCategoryList: [
        { text: 'All', value: null },
        { text: 'Sari Sari Store', value: 'sss' },
        { text: 'Non Sari Sari Store', value: 'nsss' },
      ],
      kycAccountStatusList: [
        { text: 'All', value: null },
        { text: 'Live', value: 'Live' },
        { text: 'Freeze', value: 'Freeze' },
        // { text: 'Pending Verification', value: 'PendingVerification' },
        { text: 'Failed Verification', value: 'FailedVerification' },
        { text: 'Manual Verification', value: 'ManualVerification' },
      ],
      walletUserFilterList: [
        { text: 'All', value: null },
        { text: 'Yes', value: 'Yes' },
        { text: 'No', value: 'No' },
      ],
      mdrUserFilterList: [
        { text: 'All', value: null },
        { text: 'Default (No MDR)', value: 0 },
        { text: 'With MDR', value: 1 },
      ],
      rangeOptions: {
        mode: "range",
      },

      actionIndex: -1,
      searching: false,
      prev_sort: '',
      dateFilterOptions: [
        { text: 'Date Registered', value: 'created_at' },
        { text: 'KYC Date Verification', value: 'kyc_verified_at' },
      ],
      showGenerateKycModal: false,
      showGenerateKycSuccessModal: false,
      hasGeneratedLink: false,
      userToReKyc: {},
      generatedKycLink: '',
      linkIsExpired: false,
    };
  },
  components: {
    flatPickr,
    Paginationv2
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.dataList.length;
    },
    ...customerListComputed,
    ...erpFixMessages,
    ...peddlrWalletKycComputed
  },
  mounted() {
    // Set the initial number of items
    // this.totalRows = this.dataList.length;
    this.changeTitle({title: 'Merchant List'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'} },
        { text: 'Merchant List', to: { name: 'Merchant'} }
      ]
    });
    try {
      var prev_filter = JSON.parse(localStorage.getItem("merchantFilter"));
      this.currentPage = prev_filter.page
      this.perPage = prev_filter.rows
      this.searchValue.search = prev_filter.search
      this.searchValue.searchField = prev_filter.searchField
      this.searchValue.kycStatus = prev_filter.kycStatus
      this.searchValue.kycAccountType = prev_filter.kycAccountType
      this.searchValue.kycAccountStatus = prev_filter.kycAccountStatus
      this.searchValue.walletUser = prev_filter.walletUser
      this.searchValue.dateRange = prev_filter.dateRange
      this.searchValue.sort = prev_filter.sort
      this.searchValue.orderDesc = prev_filter.orderDesc
      this.searchSubscriber();
      console.log(">> prev filter:",prev_filter);
    } catch (error) {
      //var date_today = moment().format('YYYY-MM-DD');
      //var date_range = date_today + ' to ' + date_today;
      //this.searchValue.dateRange = date_range
      //this.searchValue.walletUser = "Yes"
      this.searchSubscriber();
    }
    this.fetchMDR();
  },
  methods: {
    ...layoutMethods,
    ...customerMethods,
    ...exportMethods,
    ...peddlrWalletKycMethods,
    async onExport(){
      await this.onPageUpdate();
      if(this.subscriberList.length ==0){
        Swal.fire("Failed!", this.exportNullPrompt, "warning");
        return;
      }
      let params = Object.assign(
        this.searchValue, 
        {
          module: 'merchant_info',
          email: JSON.parse(localStorage.getItem('userData')).email
        });

      delete params.page;
      delete params.rows;
      
      this.exportReportExt(params)
        .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
        .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
    },
    async getSubsList() {
      await this.getSubscriberListv2({
        page: this.currentPage,
        rows: this.perPage
     })
    },
    async searchSubscriber() {
      localStorage.setItem("merchantFilter", JSON.stringify({
        page: this.currentPage,
        rows: this.perPage,
        ...this.searchValue
      }));
      // localStorage.removeItem('merchantFilter');
      await this.getSubscriberListv2({
        page: this.currentPage,
        rows: this.perPage,
        ...this.searchValue
      })
    },
    async onPageUpdate(reset = "") {
      // alert(JSON.stringify(this.searchValue))
      // add if condition
      if(this.searching || this.searchValue.kycStatus != null || 
         this.searchValue.kycAccountType != null || this.searchValue.kycAccountStatus != null || 
         this.searchValue.walletUser != null ||
         this.searchValue.dateRange != null || this.searchValue.sort != null) {
        if(reset == "reset"){
          this.currentPage = 1
        }
        await this.searchSubscriber()
      } else {
        await this.getSubsList()
      }
    },
    onSearch() {
      this.currentPage = 1
      if (this.searchValue.search) {
        this.searching = true
        this.searchSubscriber()
      } else {
        this.searching = false
        this.searchValue = {
          search: null,
          searchField: null,
        }
        this.getSubsList()
      }
    },
    merchantsort(ctx){
      if(ctx.sortBy.length > 1){
        this.searchValue.sort = ctx.sortBy;
        this.searchValue.orderDesc = ctx.sortDesc;
        console.log(">> sorting",this.searchValue);
        if(this.prev_sort != ctx.sortBy){
          this.prev_sort = ctx.sortBy
          this.currentPage = 1
        }
        this.searchSubscriber();
      }
    },
    refresh(){
      // REMOVED the clear filter functionality in Refresh button
      // this.searchValue = {
      //   search: null,
      //   searchField: null,
      //   kycStatus : null,
      //   kycAccountType : null,
      //   kycAccountStatus : null,
      //   dateRange: null,
      //   sort: 'id',
      //   orderDesc: true
      // }
      // localStorage.removeItem('merchantFilter');

      this.currentPage = 1
      this.perPage = 10

      this.onPageUpdate('reset');
    },
    onDisplayChange(){
      console.log(this.subscriberListTotal,this.perPage,this.subscriberList.length,(this.subscriberList.length < this.subscriberListTotal && this.subscriberList.length != this.perPage));
      if(
        (this.subscriberList.length < this.subscriberListTotal && this.subscriberList.length != this.perPage) || // condition for incrementing display per page
        (this.subscriberList.length == this.subscriberListTotal && this.perPage < this.subscriberList.length) // condition for decreasing display per page
        ){
        this.onPageUpdate('reset')
      }
    },
    isEmpty(value){
        return (
        // null or undefined
        (typeof value == "undefined") || 
        (value == undefined) ||
        (value == null) ||
        (value === "") ||
        // has length and it's zero
        (Object.prototype.hasOwnProperty.call(value,'length') && value.length === 0) ||
        // is an Object and has no keys
        (value.constructor === Object && Object.keys(value).length === 0)
        )
    },
    async generateKycLink() {
      await this.generateKycUrl({
        userId: this.userToReKyc.subscriberId,
      })
      .then(async () => {
        await this.searchSubscriber();
        this.userToReKyc = {};
        this.generatedKycLink = this.generatedKycUrl;
        this.showGenerateKycModal = false;
        this.showGenerateKycSuccessModal = true;
      })
    },
    async onCopyLinkClicked() {
      try {
        if (this.userToReKyc.isKycUrlExpired) {
          this.showGenerateKycSuccessModal = false;
          this.showGenerateKycModal = true;
        } else {
          await navigator.clipboard.writeText(this.generatedKycLink)
            .then(() => {
              this.showGenerateKycSuccessModal = false;
              this.$toast.showToast('link', 'Copied Generated Link', 'Successfully copied the generated link');
              this.generatedKycLink = '';
            });
        }
      } catch (error) {
        console.log("Error while copying link: ", error);
      }
    },
    async fetchMDR(){
        // let self = this;
        // await this.getKankolekMDR().then((res)=>{
        //   // console.log("getKankolekMDR",res);
        //   let dynamicMdr= res?.mdrOptions??[];
        //   dynamicMdr.forEach(key => {
        //     this.mdrUserFilterList.push(key);
        //   })
        // });
    },
    async onPageChange(page) {
      this.currentPage = page;
      if(this.searching || this.searchValue.kycStatus != null || 
         this.searchValue.kycAccountType != null || this.searchValue.kycAccountStatus != null || 
         this.searchValue.walletUser != null ||
         this.searchValue.dateRange != null || this.searchValue.sort != null) {
        await this.searchSubscriber()
      } else {
        await this.getSubsList()
      }
    }
  },
};
</script>


<style scoped>
  .customer-name {
    color:#804997;
  }
  .color-amber {
    color: #DC7512;
  }

  .generateKycBtn {
    padding: 3px 9px;
    font-size: small;
    background-color: #9A211F;
    border-color: #9A211F;
  }

  .generatedKycButton {
    padding: 3px 9px;
    font-size: small;
  }

  .generateKycBtn, .generateKycBtn:hover, .btn-ok, .btn-ok:hover {
    background-color: #9A211F;
    border-color: #9A211F;
  }

  .bx-user-pin {
    font-size: 90px;
    color: #9A211F;
  }

  .note-txt {
    color: #9A211F;
    font-size: smaller;
  }

  .btn-cancel {
    border: 2px solid #B6B2EC;
  }

  .success-kyc-div {
    padding: 1rem 3.5rem;
  }

  .check-icon {
    width: 90px;
    height: 90px;
  }

  .bx-link {
    font-size: 20px;
  }

  .copy-link-btn {
    padding-left: 5px;
    padding-right: 5px;
    width: 142px;
  }
</style>


<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <!--h5 class="card-title">
                    <span class="text-muted fw-normal ms-2">{{subscriberListTotal}}</span>
                    Record(s)
                  </h5-->
                </div>
              </div>
              <!-- end col -->
              <div class="col-md-6" style="text-align: right;">
                <button class="btn btn-secondary" @click="refresh()">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; Refresh
                </button>
              </div>
              
              <!-- Search and button -->
              <div class="d-flex flex-wrap mt-3 mb-2 px-3">
                <div class="me-2 mb-2">
                  <b-form-group description="Search Keyword">
                    <form class="d-flex" @submit.prevent="onSearch()" >
                      <b-form-group id="input-group-3" label-for="input-3">
                        <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                          id="input-3"
                          v-model="searchValue.searchField"
                          :options="searchList"
                        ></b-form-select>
                      </b-form-group>

                      <b-input-group>
                        <b-form-input v-model="searchValue.search" class="rounded-0"></b-form-input>
                        <b-input-group-append v-if="false">
                          <b-button variant="primary" type="submit" class="rounded-0 rounded-end px-2">
                            <i class='bx bx-search bx-fw'></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </form>
                  </b-form-group>
                </div>
                <!-- <div class="me-2"> -------- This Filter was replaced by: Filter by KYC Account Type, and Filter by KYC Account Status
                 <b-form-group label-for="kyc-status" description="Filter by KYC">
                    <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                      id="kyc-status"
                      v-model="searchValue.kycStatus"
                      :options="kycList"
                    ></b-form-select>
                  </b-form-group>
                </div> -->
                <div class="me-2">
                 <b-form-group label-for="kyc-account-type" description="Filter by KYC Account Type">
                    <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                      id="kyc-account-type"
                      v-model="searchValue.kycAccountType"
                      :options="kycAccountTypeList"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="me-2">
                 <b-form-group label-for="kyc-account-status" description="Filter by KYC Account Status">
                    <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                      id="kyc-account-status"
                      v-model="searchValue.kycAccountStatus"
                      :options="kycAccountStatusList"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="me-2">
                 <b-form-group label-for="store-category" description="Filter by Store Category">
                    <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                      id="store-category"
                      v-model="searchValue.storeCategory"
                      :options="storeCategoryList"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="me-2">
                 <b-form-group label-for="wallet-user" description="Filter by Wallet user">
                    <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                      id="wallet-user"
                      v-model="searchValue.walletUser"
                      :options="walletUserFilterList"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="me-2">
                 <b-form-group label-for="mdr-user" description="Filter by MDR user">
                    <div class="d-flex align-items-center">
                      <!-- Info icon with tooltip -->
                      <b-tooltip target="mdr-user" triggers="hover" placement="top">
                        Applicable only in the export report.
                      </b-tooltip>

                      <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                        id="mdr-user"
                        v-model="searchValue.mdrUser"
                        :options="mdrUserFilterList"
                      ></b-form-select>
                    </div>
                  </b-form-group>
                </div>
                <div class="me-2 d-flex">
                  <b-form-group id="input-group-3" label-for="input-3" description="Filter by date">
                    <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                      id="input-3"
                      v-model="searchValue.dateKeyword"
                      :options="dateFilterOptions"
                    ></b-form-select>
                  </b-form-group>
                  <b-form-group>
                    <flat-pickr
                      v-model="searchValue.dateRange"
                      :config="rangeOptions"
                      placeholder="Select a date range"
                      class="form-control"
                      style="width: 250px"
                    ></flat-pickr>
                  </b-form-group>
                </div>
                <div class="me-2">
                  <a class="btn btn-primary h-fit" @click="onPageUpdate('reset')">
                    <i class='bx bx-search bx-fw'></i>Search
                  </a>
                </div>
                <div class="me-2">
                  <b-form-group label="">
                    <b-button variant="primary" type="button" @click="onExport" class="px-2 btn btn-primary h-fit">
                      <i class='uil uil-export me-1'></i> Export
                    </b-button>
                  </b-form-group>
                </div>
              </div>
            </div>
              <!-- end col -->
            <!-- end row -->

            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="subscriberList"
                  :fields="fields"
                  responsive="sm"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  class="table-check"
                  @sort-changed="merchantsort"
                >


                  <template #cell(name)="data">
                    <span class="text-body m-0" :title="data.item.subscriberName || data.item.cogUserName || data.item.subscriberId">
                      <!-- <router-link :to="{ name: 'Subscriber Detail', params: { id: data.item.subscriberId }}" class="customer-name"> -->
                      <router-link :to="{ name: 'Profile Information', params: { tab: 'Profile', bid: data.item.businessId}}" class="customer-name">
                        {{ data.item.subscriberName || data.item.cogUserName || data.item.subscriberId | truncator(20,'...')}}
                      </router-link>
                    </span>
                  </template>

                  <template #cell(business_name)="data">
                    <span class="text-body m-0">
                      <!-- <router-link :to="{ name: 'Business Detail', params: { id: data.item.businessId }}"> -->
                      <router-link :to="{ name: 'Profile Information', params: { tab: 'Business', bid: data.item.businessId }}">
                        {{ data.item.businessName }}
                      </router-link>
                    </span>
                  </template>

                  <template #cell(mdr)="data">
                    <p class="text-body m-0">{{ 
                      ((data.item.mdr?.isWhitelisted?? false) && (data.item.mdr?.onMdr?? false) ?
                      data.item.mdr?.mdrName??"" : 
                      "Default - Kolek Fee")
                      | notEmpty}}</p>
                  </template>

                  <template #cell(contact_info)="data">
                    <p class="text-body m-0">{{ data.item.subscriberMobileNumber }}</p>
                  </template>

                  <template #cell(email)="data">
                    <p class="text-body m-0 text-center">{{ isEmpty(data.item.subscriberEmail) ? '--':data.item.subscriberEmail  }} </p>
                  </template>

                  <template #cell(manual_kyc)="data">
                    <div v-if="data.item.kyc_acct_type != 'NoKYC' && data.item.kyc_acct_type != `Don't Have KYC` && !isEmpty(data.item.kyc_acct_type)">
                        <b-button v-if="data.item.kycUrl != null" variant="primary" type="button" class="btn btn-primary generatedKycButton px-4 w-100" 
                          @click="userToReKyc = data.item; generatedKycLink = data.item.kycUrl; showGenerateKycSuccessModal = true">Generated Re-KYC Link</b-button>
                        <b-button v-else type="button" class="btn btn-danger generateKycBtn px-4 w-100" 
                          @click="userToReKyc = data.item; showGenerateKycModal = true">Generate Re-KYC Link</b-button>
                    </div>
                  </template>   

                  <template #cell(birthdate)="data" v-if="false">
                    <p class="text-body m-0">{{ data.item.subscriberBirthDate | formatDateOnly }} </p>
                  </template>

                  <!-- <template #cell(KYC_status)="data">
                    <p class="text-body m-0" >{{data.item.kyc_details !== null ? data.item.kyc_details.kyc_status ? data.item.kyc_details.kyc_status.status : 'Don\'t have KYC' :  'Don\'t have KYC'}}</p>
                  </template> -->

                  <template #cell(KYC_account_type)="data">
                    <p class="text-body m-0" >
                      {{ isEmpty(data.item.kyc_acct_type) ? "--" : data.item.kyc_acct_type }}
                    </p>
                  </template>

                  <template #cell(KYC_account_status)="data"> 
                    <p class="text-capitalize fw-medium m-0" 
                      :class="{ 
                        'text-success': data.item.kyc_acct_status == 'Live',
                        'text-danger': data.item.kyc_acct_status == 'Failed Verification',
                        'color-amber': data.item.kyc_acct_status == 'Pending Verification'
                      }">
                      {{ isEmpty(data.item.kyc_acct_status) ? "--" : data.item.kyc_acct_status }}
                    </p>
                  </template>

                  <template #cell(wallet_account_number)="data">
                    <p class="text-body m-0">
                      {{ isEmpty(data.item.walletAccountNumber) ? "--" : data.item.walletAccountNumber }}
                    </p>
                  </template>

                  <template #cell(wallet_user)="data">
                    <p class="text-body m-0">{{ data.item.walletUser }}</p>
                  </template>

                  <template #cell(kk_registration_date)="data">
                    <p class="text-body m-0" v-if="data.item.kk_registration_date">{{ data.item.kk_registration_date | formatDate  }}</p>
                    <p class="text-body m-0" v-else>--</p>
                  </template>

                  <template #cell(registered)="data">
                    <p class="text-body m-0">{{ data.item.registered | formatDate }}</p>
                  </template>

                  <template #cell(kyc_verified_at)="data">
                    <p class="text-body m-0">{{ data.item.kyc_verified_at | formatDate  }}</p>
                  </template>

                  <template #cell(storeCategory)="data">
                    <p class="text-body m-0">{{ data.item.storeCategory | readableStoreCategory}}</p>
                  </template>

                  <template #cell(latestKycFailedReason)="data">
                    <p class="text-body m-0">
                      <span v-if="!isEmpty(data.item.latestKycFailedReason)" :title="data.item.latestKycFailedReason" class="kyc-popover">
                          {{ data.item.latestKycFailedReason | truncator(30,"...") }}</span>
                      <span v-else>--</span>
                    </p>
                  </template>

                </b-table>
              </div>
            </div>
            <!-- end table responsive -->
            <div class="row g-0 text-center" v-if="subscriberList.length == 0">
              <span>No data to display.</span>
            </div>
             <template>
                      <div class="pagination-v2" v-if="subscriberList.length != 0">
                        <paginationv2
                          :totalPages="10"
                          :perPage="10"
                          :currentPage="currentPage"
                          :nextPageCount="subscriberListTotal"
                          @pagechanged="onPageChange"
                        />
                      </div>
                    </template>
            <div class="row g-0 text-center text-sm-start" v-if="subscriberListTotal != 0 && subscriberListTotal > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="perPage"
                            :options="pageOptions"
                            @change="onDisplayChange()"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                   
                    <div
                      class="dataTables_paginate paging_simple_numbers float-end" 
                      v-if="subscriberListTotal > perPage"
                    >
                      <!-- pagination -->
                      <!--b-pagination
                        class="pagination-rounded"
                        v-model="currentPage"
                        :total-rows="subscriberListTotal"
                        :per-page="perPage"
                        @input="onPageUpdate"
                      ></b-pagination-->
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->


    <!-- #region Generate KYC Link Modal -->
    <b-modal v-model="showGenerateKycModal" size="md" centered hide-header hide-footer hide-header-close no-close-on-backdrop>
      <div class="px-2 py-3">
        <div class="col-md-12 text-center">
          <i class="bx bx-user-pin mb-1"></i>
          <p class="fw-bold mt-2" style="font-size: 1.5em;">Generate Re-KYC</p>
          <p class="mt-2 mb-4">You are about to generate a re-KYC link and delete the information of the user. Please secure their consent before confirming.</p>
          <p class="small fst-italic note-txt">*Please note that the data will not be retrieved anymore once you confirm.</p>
          <div class="d-flex justify-content-center mt-4">
            <b-button type="button" variant="light" class="w-sm btn-cancel" @click="userToReKyc = {}; showGenerateKycModal = false" >Cancel</b-button>
            <b-button type="button" class="btn w-sm ms-2 btn-ok" @click="generateKycLink()">Confirm</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- #endregion -->

    <!-- #region Generate KYC Link Successful Modal -->
    <b-modal v-model="showGenerateKycSuccessModal" size="md" centered hide-header hide-footer hide-header-close no-close-on-backdrop>
      <div class="success-kyc-div">
        <div class="col-md-12 text-center">
          <i class="bx bx-user-pin mb-1" style="color: #B0DA8F;" v-if="!isEmpty(generatedKycLink)"></i>
          <img src="@/assets/images/check-circle.png" alt="Check Circle Icon" class="mb-1 check-icon" v-else>
          <p class="fw-bold mt-2" style="font-size: 1.5em;" v-if="!isEmpty(generatedKycLink)">Generated Re-KYC</p>
          <p class="fw-bold mt-2" style="font-size: 1.5em;" v-else>Generate Re-KYC Successful!</p>
          <p class="mt-2 mb-4">Please copy the generated link and send to the merchant so they can undergo re-KYC.</p>
          <div class="d-flex">
            <b-form-input disabled class="rounded-0 rounded-start" v-model="generatedKycLink"></b-form-input>
            <b-button type="button" variant="primary" class="btn btn-primary rounded-0 rounded-end d-flex copy-link-btn" @click="onCopyLinkClicked()">
              <i class="bx bx-link"></i>Copy Link
            </b-button>
          </div>
          <p v-if="userToReKyc.isKycUrlExpired" class="small fst-italic note-txt mt-2">*Link has expired. Clicking Copy Link will generate a new link.</p>
          <div class="d-flex justify-content-center mt-4">
            <b-button type="button" variant="light" class="w-sm btn-cancel" @click="showGenerateKycSuccessModal = false">OK</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- #endregion -->
  </div>
</template>